// scroll bar
import "simplebar/src/simplebar.css";

import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Provider } from "react-redux";

import { PersistGate } from "redux-persist/integration/react";
import Amplify from "aws-amplify";

import "semantic-ui-css/semantic.min.css";

//

// ----------------------------------------------------------------------

import {
  ApolloClient,
  ApolloProvider,
  ApolloLink,
  createHttpLink,
} from "@apollo/client";

import { InMemoryCache } from "@apollo/client/cache";

import { createAuthLink } from "aws-appsync-auth-link";
import { createSubscriptionHandshakeLink } from "aws-appsync-subscription-link";
import { store, persistor } from "./redux/store";
import amplifyConfig from "./config/amplify";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import reportWebVitals from "./reportWebVitals";
import ModalManager from "./components/ModalManager/ModalManager";

Amplify.configure({
  Auth: {
    identityPoolId: amplifyConfig.cognito.IDENTITY_POOL_ID,
    region: amplifyConfig.cognito.REGION,
    userPoolId: amplifyConfig.cognito.USER_POOL_ID,
    userPoolWebClientId: amplifyConfig.cognito.APP_CLIENT_ID,
  },
  Storage: {
    AWSS3: {
      bucket: amplifyConfig.s3.BUCKET,
      region: amplifyConfig.s3.REGION,
    },
  },
});

const url = process.env.REACT_APP_APPSYNC_GRAPHQL_ENDPOINT;
const region = process.env.REACT_APP_APPSYNC_GRAPHQL_REGION;
const auth = {
  type: process.env.REACT_APP_APPSYNC_GRAPHQL_TYPE_AUTH,
  apiKey: process.env.REACT_APP_APPSYNC_GRAPHQL_API_KEY,
};

const httpLink = createHttpLink({ uri: url });

const link = ApolloLink.from([
  createAuthLink({ url, region, auth }),
  createSubscriptionHandshakeLink(url, httpLink),
]);

const clientApollo = new ApolloClient({
  link,
  cache: new InMemoryCache(),
});

ReactDOM.render(
  <HelmetProvider>
    <Provider store={store}>
      <BrowserRouter>
        <PersistGate persistor={persistor}>
          <ApolloProvider client={clientApollo}>
            <ModalManager />
            <App />
          </ApolloProvider>
        </PersistGate>
      </BrowserRouter>
    </Provider>
  </HelmetProvider>,
  document.getElementById("root")
);

// If you want to enable client cache, register instead.
serviceWorker.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
